<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="76" height="76" fill="none">
    <path
      d="M6.75 75.5a6 6 0 0 1-4.38-1.88A6 6 0 0 1 .5 69.25V6.75a6 6 0 0 1 1.88-4.38A6 6 0 0 1 6.75.5h62.5a6 6 0 0 1 4.38 1.88 6 6 0 0 1 1.87 4.37v62.5a6 6 0 0 1-1.88 4.38 6 6 0 0 1-4.37 1.87H6.75Zm0-6.25h62.5V6.75H6.75v62.5Zm5.83-10.1h50.94L48.21 38.73 34.46 56.54l-9.69-13.23-12.19 15.84Zm10.85-30.52a5 5 0 0 0 3.68-1.53 5.06 5.06 0 0 0 1.52-3.7 5 5 0 0 0-1.53-3.68 5.06 5.06 0 0 0-3.7-1.51 5 5 0 0 0-3.68 1.52 5.06 5.06 0 0 0-1.51 3.7 5 5 0 0 0 1.52 3.68 5.06 5.06 0 0 0 3.7 1.52Z"
      fill="#D7D3E8"
    />
  </svg>
</template>
